import { disputeAlertSchema_ } from "@redotech/redo-dispute-db-schema/dispute-alert-definition";
import * as z from "zod";

/**
 * The alert row as served to the merchant Alerts list/detail and the admin
 * Alerts tab. Drops `rawAlert` (heavy, vendor-internal) but keeps the rest;
 * `accountId` stays for the admin merchant join — the merchant UI ignores it.
 * Mirrors disputeViewSchema for disputes.
 */
const disputeAlertViewSchema_ = disputeAlertSchema_.omit({ rawAlert: true });

export const disputeAlertViewSchema: z.ZodType<DisputeAlertView> =
  disputeAlertViewSchema_;

export interface DisputeAlertView
  extends z.infer<typeof disputeAlertViewSchema_> {}

// Exported raw object so the admin row schema can `.extend` it (teamName/teamId).
export { disputeAlertViewSchema_ };
